import { Component, HostBinding, Input } from '@angular/core'
import * as lodash from 'lodash'

interface SignOrderItem {
  role?: string
  name?: string
  order?: number
}

@Component({
  selector: 'app-signing-diagram',
  templateUrl: './signing-diagram.component.html',
  styleUrls: ['./signing-diagram.component.scss'],
})
export class SigningDiagramComponent {
  @Input() order: number
  @Input() last: boolean
  @Input() first: boolean
  @Input() total: number
  @Input() set items(data: SignOrderItem[]) {
    this.data = this.normalize(data)
  }
  @Input() labelKey: string

  @HostBinding('class') get hostClasses() {
    return this.data.length > 1 ? 'multiple' : 'single'
  }

  data: SignOrderItem[] = []

  constructor() {}

  normalize(data: SignOrderItem[]) {
    const getSignerName = (data: any) => {
      return lodash.get(data, this.labelKey) || lodash.get(data, 'role')
    }

    return (
      lodash
        .chain(data)
        .filter((t) => !!getSignerName(t))
        // .uniqBy(t => getSignerName(t))
        .map((t) => ({ role: getSignerName(t), order: t.order }))
        .value()
    )
  }

  getInitials(role: string) {
    return lodash
      .split(role, ' ')
      .map((s) => lodash.trim(s))
      .filter((t) => !!t)
      .map((t) => lodash.toUpper(t[0]))
      .slice(0, 2)
      .join('')
  }
}
